import { Injectable, inject } from '@angular/core';
import { isNullOrUndefined } from 'util';
import { Subject } from 'rxjs';

import { JobData } from './jobs.types';

@Injectable({
  providedIn: 'root'
})
export class JobsService {
  public jobs: Map<string, Job>;
  public jobs$ = new Subject<void>();

  constructor() {
    this.jobs = new Map([]);
  }

  public add(job: Job): boolean {
    const result = !!this.jobs.set(job.code, job);
    this.jobs$.next();
    return result;
  }

  public remove(code: string): boolean {
    if (!code) return false;
    const result = this.jobs.delete(code.toUpperCase());
    this.jobs$.next();
    return result;
  }

  public get hasJobs(): boolean {
    return !isNullOrUndefined(this.jobs) ? this.jobs.size > 0 : false;
  }
}

export class Job implements JobData {
  public code: string;
  public title: string;
  public description: string;

  constructor(data: JobData) {
    data.code = data.code.toUpperCase();
    Object.assign(this, data);
  }
}
